/**
 * Convert a thrown error into a structured CloudErrorPayload for SET_ERROR dispatch.
 * Reads `code`/`suggestion`/`status` augmentations attached by DataCloudChunkedUploader
 * (T7) on non-OK responses. The reducer stores the payload; the render layer translates
 * via cloudBackendErrorMapper at render time so language switches re-translate.
 *
 * W10-FE1: automatically sets `persistent=true` for critical BE error codes that
 * require user acknowledgment (quota, capacity, data-integrity errors).
 */
import i18n from 'i18next';
import type { CloudErrorPayload } from '../types/dataCloud.types';
import { isPersistentCloudErrorCode } from './cloudPersistentErrorCodes';

export function cloudErrorPayloadFromError(err: unknown): CloudErrorPayload {
  const e = err as Error & { code?: string; suggestion?: string };
  return {
    code: e?.code,
    suggestion: e?.suggestion,
    fallback: e?.message ?? i18n.t('dataCloud:errors.unknown', { defaultValue: 'Unknown error' }),
    persistent: isPersistentCloudErrorCode(e?.code),
  };
}
